import { jsonGet } from "../../../Boilerplate/api";

// Plan/billing endpoints. Checkout + portal helpers live in shared Boilerplate and
// hit the NBoilerplate Stripe controllers; re-exported here for convenience.
export {
  checkoutSubscription,
  checkoutCredits,
  customerPortal,
} from "../../../Boilerplate/api";

export const getEntitlements = () => jsonGet("entitlements");

export const getCreditProducts = () => jsonGet("payment/stripe/products");

// Read-only spend report over the credit ledger (what the tenant has spent, by action).
export const getCreditLedger = () => jsonGet("credit-ledger");
